import { render, staticRenderFns } from "./FormsHandbookView.vue?vue&type=template&id=1b709eab&"
import script from "./FormsHandbookView.vue?vue&type=script&lang=js&"
export * from "./FormsHandbookView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports